import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  backButton?: React.ReactNode;
  otherButtons?: React.ReactNode;
  nextButton?: React.ReactNode;
  registerButton?: React.ReactNode;
}

const EditingReportActionButtons: React.FC<Props> = ({ backButton, otherButtons, nextButton, registerButton }) => {
  return (
    <Row>
      <Col md={9} lg={9}>
        <div className="fixed-action-footer-main">
          <div className="fixed-action-footer-left">{backButton}</div>
          <div className="fixed-action-footer-actions">
            <div className="fixed-action-footer-center">{otherButtons}</div>
            <div className="fixed-action-footer-right">{nextButton}</div>
          </div>
        </div>
      </Col>
      <Col md={3} lg={3}>
        <div className="fixed-action-footer-help">{registerButton}</div>
      </Col>
    </Row>
  );
};

export default EditingReportActionButtons;
